import {
  dialog
} from './../../base';

function getMyBalloonContentLayoutClass() {
  return ymaps.templateLayoutFactory.createClass('<div class="fly-baloon"><p class="fly-baloon__type">{{properties.balloonType}}</p><h3 class="fly-baloon__address">{{properties.balloonContentBody}}</h3><p class="fly-baloon__time">{{properties.balloonContentTime}}</p>{% if properties.balloonWay %}<p class="fly-baloon__way">{{properties.balloonWay}}</p>{% endif %}</div>');
}

export function setBaloonLayout() {
  ymaps.layout.storage.add('fixmobile#baloonLayout', getMyBalloonContentLayoutClass());
}

export class Baloon {
  constructor(obj) {
    this.elem = null;
    this.callback = {};

    this.closeButtonClickHandler = this.closeButtonClickHandler.bind(this);
    this.backButtonClickHandler = this.backButtonClickHandler.bind(this);
    this.okButtonClickHandler = this.okButtonClickHandler.bind(this);

    this.init(obj);
  }

  getElem() {
    return this.elem;
  }

  init(obj) {

    if (this.elem) {
      this.destroy();
    }

    let address = obj.properties.balloonContentBody;
    let price = obj.properties.iconContent;
    let company = obj.properties.hintContent;
    let time = obj.properties.balloonWorkTime;
    let dates = obj.properties.balloonTimeDelivery;
    let pointId = obj.id;

    this.elem = this.create(address, price, company, time, dates, pointId);

    this.id = String(pointId);
    this.company = company;

  }

  create(address, price, company, time, dates, pointId) {

    let template = document.querySelector('#map__data').content.querySelector('.map__baloon');
    let cloneTemplate = template.cloneNode(true);
    let closeButton = cloneTemplate.querySelector('.baloon__close');
    let backButton = cloneTemplate.querySelector('.baloon__back');
    let okButton = cloneTemplate.querySelector('.baloon__button');

    cloneTemplate.querySelector('.baloon__adress').textContent = address;
    cloneTemplate.querySelector('.baloon__price').textContent = `${price} p.-`;
    cloneTemplate.querySelector('.baloon__hours').textContent = time;
    cloneTemplate.querySelector('.baloon__dates').textContent = `${dates} дн.`;

    switch (company) {
      case 'СДЭК':
        cloneTemplate.dataset.company = 'СДЭК';
        break;
      default:
        throw new Error('Неизвестная компания');
    }

    cloneTemplate.dataset.id = pointId;

    closeButton.addEventListener('click', this.closeButtonClickHandler);
    backButton.addEventListener('click', this.backButtonClickHandler);
    okButton.addEventListener('click', this.okButtonClickHandler);

    return cloneTemplate;
  }


  destroy() {
    this.elem.remove();
    this.elem = null;
  }

  setClickHandler(callback) {
    this.callback = callback;
  }

  closeButtonClickHandler() {
    this.callback();
  }

  backButtonClickHandler() {
    this.callback();
  }

  okButtonClickHandler() {

    if (this.company === 'СДЭК') {
      window.cart.selected('id13', this.id);
    } else if (this.company === 'ТК Энергия') {
      window.cart.selected('id1', this.id);
    }

    dialog.hide();
  }
}
